import { Component, Input } from '@angular/core';

@Component({
    selector: 'review-buyer-configuration-section',
    styleUrls: ['./review-buyer-configuration-section.component.scss'],
    template: `
        <div class="review-buyer-configuration-section">
            <div class="section-header">
                {{ sectionTitle }}
            </div>
            <div class="section-body">
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class ReviewBuyerConfigurationSectionComponent {
    @Input() public sectionTitle: string;
}
